import React, { useContext, useEffect, useState } from 'react';
import {
    Box,
    Typography,
    IconButton,
    Collapse,
    Divider,
    Tooltip,
    CircularProgress,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Button
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Plus } from 'lucide-react';
import Context from '../../context/Context';
import DeleteConfirm from '../../Common/DeleteConfirm';
import apiClient from '../../utils/apiClient';

const DisplayFaqs = () => {

     const { isConfirmDeleteModelOpen,setIsConfirmDeleteModelOpen,itemIdToDelete,
        confirmDelete } = useContext(Context);
    const [faqs, setFaqs] = useState([]);
    const [expandedId, setExpandedId] = useState(null);
    const navigate = useNavigate()
    const [errors, setErrors] = useState('')

    const [faqType, setFaqType] = useState('user')

    const types = ["user", 'technician']


    const [loading, setLoading] = useState(false)

    const fetchFaqData = async (faqType) => {
        setLoading(true)
        try {
            const response = await apiClient.get(`/faq/getfaqbytype`, {
                params: { type: faqType },
            });
            if (response.data.status === true) {
                setFaqs(response.data.data)
            }
        } catch (error) {
            setErrors(error?.response?.data?.message || "Error getting FAQs")
        }
        finally {
            setLoading(false)
        }
    };

    useEffect(() => {
        fetchFaqData(faqType);
    }, [faqType]);

    const toggleExpand = (id) => {
        setExpandedId(expandedId === id ? null : id);
    };

    const handleEdit = (faq) => {
        navigate('/create-edit-faqs', { state: { faq } });
    };

    const handleDelete = async () => {
        setIsConfirmDeleteModelOpen(false)
        setLoading(true)
        try {
            const response = await apiClient.delete(`/faq/deletefaq/${itemIdToDelete}`);
            if (response.data.status === true) {
                toast.success(response.data.message)
                fetchFaqData(faqType)
            }

        } catch (error) {
            setErrors(error?.response?.data?.message || "Error deleting FAQ")
        }
        finally{
            setLoading(false)
        }
    };
    const handleTypeChange = (event) => {
        setFaqType(event.target.value);
        setExpandedId(null);
    };

      const handleAddClick = () => {
        navigate('/create-edit-faqs',);
    };



    return (
        <>
        <Box mt={1} sx={{ padding: { sm: 2, xs: 2, md: 4, lg: 4 } }} >
            <Typography variant="h4" mb={2} textAlign="left">
                Frequently Asked Questions
            </Typography>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center',  }}>

            <FormControl sx={{ minWidth: 150 }} size="small">
                <InputLabel id="faq-type-label">FAQ Type</InputLabel>
                <Select
                    labelId="faq-type-label"
                    id="faq-type-select"
                    value={faqType}
                    label="FAQ Type"
                    onChange={handleTypeChange}
                >
                    {types.map(type => (
                        <MenuItem key={type} value={type}>
                            {type.charAt(0).toUpperCase() + type.slice(1)}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>

            <Button
                variant="contained"
                sx={{ borderRadius: "25px", padding: "10px 20px", display: "flex", gap: 1 }}
                onClick={handleAddClick}
            >
                <Plus size={23} />
                <Typography>Add Faq</Typography>
            </Button>
            </Box>

            {loading ? (
                <Box display="flex" justifyContent="center" alignItems="center" height={200}>
                    <CircularProgress />
                </Box>
            ) : (

                faqs.length > 0 ? (
                    faqs.map((faq, index) => (
                        <Box key={faq.id}>
                            <Box
                                display="flex"
                                alignItems="flex-start"
                                sx={{ py: 2, cursor: 'pointer' }}
                                onClick={() => toggleExpand(faq.id)}
                            >
                                <Box mt={0.5}>
                                    {expandedId === faq.id ? <RemoveIcon color="primary" /> : <AddIcon color="primary" />}
                                </Box>
                                <Typography
                                    variant="subtitle1"
                                    fontWeight={expandedId === faq.id ? 600 : 500}
                                    ml={2}
                                    flex={1}
                                >
                                    {index + 1} {". "}
                                    {faq.question}
                                </Typography>
                                <Box>
                                    <Tooltip title="Edit">
                                        <IconButton size="small" onClick={(e) => { e.stopPropagation(); handleEdit(faq); }}>
                                            <EditIcon fontSize="small" />
                                        </IconButton>
                                    </Tooltip>
                                    <Tooltip title="Delete">
                                        <IconButton size="small" onClick={(e) => { e.stopPropagation(); confirmDelete(faq.id); }}>
                                            <DeleteIcon fontSize="small" color="error" />
                                        </IconButton>
                                    </Tooltip>
                                </Box>
                            </Box>
                            <Collapse in={expandedId === faq.id} timeout="auto" unmountOnExit>
                                <Typography
                                    variant="body2"
                                    sx={{ color: '#555', pl: 5, pr: 2, pb: 2 }}
                                    dangerouslySetInnerHTML={{ __html: faq.answer }}
                                />
                            </Collapse>
                            <Divider />
                        </Box>
                    ))
                ) : (
                    <Typography textAlign="center" mt={3}>
                        No FAQs found.
                    </Typography>
                )

            )}

            {errors &&
                <Typography variant='body2' color='error'>{errors}</Typography>
            }


        </Box>

         <DeleteConfirm open={isConfirmDeleteModelOpen} onClose={() => setIsConfirmDeleteModelOpen(false)} onConfirm={handleDelete} />
        </>
    );
};

export default DisplayFaqs;
